export default "__VITE_ASSET__gMviUXY5__"